module.exports = __webpack_public_path__ + "static/media/use1.341de15a.jpeg";